import { createContext, useContext, type ReactNode } from "react";

import type { FlowContext } from ".";

const FlowCtx = createContext<FlowContext | null>(null);

export function FlowProvider({
  value,
  children,
}: {
  value: FlowContext;
  children: ReactNode;
}) {
  return <FlowCtx.Provider value={value}>{children}</FlowCtx.Provider>;
}

export function useFlowContext(): FlowContext {
  const ctx = useContext(FlowCtx);
  if (!ctx) {
    throw new Error("useFlowContext must be used within a FlowProvider");
  }
  return ctx;
}
